export class DynamicVariables {

    public static TaskmanagerEnabled = false; 
    public static WorkloadmanagerEnabled = false; 
    public static IsUserWorkloadManager = false; 
    public static ErpDepartmentsEnabled = false; 
    public static ControlPressed = false; 
    public static AltPressed = false; 

    public static initialize() {
        var main = $(`main`);

        DynamicVariables.TaskmanagerEnabled = (main.data('task-manager-enabled') == 'True' || main.data('task-manager-enabled') == 'true');
        DynamicVariables.WorkloadmanagerEnabled = (main.data('workload-manager-enabled') == 'True' || main.data('workload-manager-enabled') == 'true');
        DynamicVariables.IsUserWorkloadManager = (main.data('is-user-workload-manager') == 'True' || main.data('is-user-workload-manager') == 'true');
        DynamicVariables.ErpDepartmentsEnabled = (main.data('erp-departments-in-use') == 'True' || main.data('erp-departments-in-use') == 'true');

        $(document).keydown(function(event) {
            switch(event.which) {
                case 17:
                    DynamicVariables.ControlPressed = true;
                    break;

                case 18:
                    DynamicVariables.AltPressed = true;
                    break;
            }
        });
        
        $(document).keyup(function() {
            DynamicVariables.ControlPressed = false;
            DynamicVariables.AltPressed = false;
        });
        
        DynamicVariables.ControlPressed = false;
        DynamicVariables.AltPressed = false;
    }
}